import { type TransactionDetail, createSolanaClient } from '@0xtorch/solana'
import type {
  FetchSolanaTransactionsParameters,
  FetchSolanaTransactionsReturnTypes,
} from './types'

export const fetchSolanaTransactions = async ({
  rpcEndpoints,
  signatures,
  headers,
  onFetched,
}: FetchSolanaTransactionsParameters): Promise<FetchSolanaTransactionsReturnTypes> => {
  const client = createSolanaClient({ rpcEndpoints })
  const transactions: TransactionDetail[] = []
  const errors = new Map<string, unknown>()

  await Promise.all(
    signatures.map((signature) =>
      (async () => {
        try {
          const transaction = await client.getTransaction({
            signature,
            headers,
          })
          if (transaction === undefined) {
            errors.set(signature, new Error('Failed to get solana transaction'))
            return
          }
          transactions.push(transaction)
        } catch (error) {
          errors.set(signature, error)
        } finally {
          onFetched(signature)
        }
      })(),
    ),
  )

  return {
    transactions,
    errors,
  }
}
